export default __webpack_public_path__ + "static/media/rocket.f09a4224.svg";